import { boolean, nullable, object, optional, string } from "superstruct";

const CustomerSchema = object({
    isVerifiedBuyer: boolean(),
    name: nullable(string()),
    isVerifiedBuyerByMerchant: boolean(),
});

export default CustomerSchema;
